"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromotion = exports.isActionPromotion = exports.requiresCustomizationModal = exports.PromotionItemDiscountStrategy = exports.PromotionActionType = exports.PromotionConditionType = exports.PromotionConditionOperator = exports.PromotionDiscountModes = exports.PromotionTypes = exports.isPromotionCode = exports.PromotionScope = void 0;
var PromotionScope;
(function (PromotionScope) {
    // La promotion est disponible dans le panier
    PromotionScope["CART"] = "cart";
    // La promotion est disponible dans le catalogue au niveau du site
    PromotionScope["CATALOG"] = "catalog";
})(PromotionScope || (exports.PromotionScope = PromotionScope = {}));
const isPromotionCode = (promotion) => {
    return typeof promotion.code !== 'undefined' && promotion.code !== null;
};
exports.isPromotionCode = isPromotionCode;
var PromotionTypes;
(function (PromotionTypes) {
    PromotionTypes["LEAST_EXPENSIVE"] = "LEAST_EXPENSIVE";
    PromotionTypes["DISCOUNT"] = "DISCOUNT";
    PromotionTypes["GIVEAWAY"] = "GIVEAWAY";
})(PromotionTypes || (exports.PromotionTypes = PromotionTypes = {}));
var PromotionDiscountModes;
(function (PromotionDiscountModes) {
    PromotionDiscountModes["PERCENTAGE"] = "PERCENTAGE";
    PromotionDiscountModes["FIXED"] = "FIXED";
})(PromotionDiscountModes || (exports.PromotionDiscountModes = PromotionDiscountModes = {}));
////////////////////////////////////////////////////////////
// Promotion speed :
// Speed burger souhaite mettre plusieurs promotions en place, mais pas dispo a date, voici quelques exemples :
// X produit offert à partir de X€ de commande (ex : 8 Nuggets offerts dès 25 € de commande / 5 Nuggets + 5 Bouchées Camembert offerts dès 40 € de commande)
// Ils vont distribuer des coupons avec des remises (certaines pourront être sur l'eshop et en restaurant, d'autres seront uniquement en restaurant sur présentation d'un coupon) :
// Ex : -20 % sur la commande (livraison, à emporter, ou sur place) → Code promo : GOGOGO
// Ex : -30 % uniquement sur place ou à emporter (sur remise du coupon)
// Ex : Menu classique simple à 7,50 € (au lieu de 12,20 €) – uniquement sur place ou à emporter (sur remise du coupon)
// X produit offert pour l'achat de X produit via un code promo (ex : 1 Kid Box offerte pour un menu acheté – tous canaux → Code promo : KIDFUN)
// Menu à X€ au lieu de X€ via un code promo (ex : Menu avec 2 burgers simples à 14 € (au lieu de 20,10 €) – tous canaux → Code promo : BIGFAIM)
// Produit à X€ au lieu de X€ via un code promo (ex : 40 Nuggets à 15 € (au lieu de 39 €) – tous canaux → Code promo : MAXINUGG
var PromotionConditionOperator;
(function (PromotionConditionOperator) {
    PromotionConditionOperator["GREATER_THAN"] = "$gt";
    PromotionConditionOperator["GREATER_THAN_OR_EQUAL"] = "$gte";
    PromotionConditionOperator["EQUAL"] = "$eq";
    PromotionConditionOperator["NOT_EQUAL"] = "$ne";
    PromotionConditionOperator["LESS_THAN"] = "$lt";
    PromotionConditionOperator["LESS_THAN_OR_EQUAL"] = "$lte";
    PromotionConditionOperator["IN"] = "$in";
    PromotionConditionOperator["NOT_IN"] = "$notIn";
})(PromotionConditionOperator || (exports.PromotionConditionOperator = PromotionConditionOperator = {}));
// Il faudrait probablement que packs et produtcs ne soient pas des arrays 
var PromotionConditionType;
(function (PromotionConditionType) {
    // 🎂 Uniquement pour les clients dont c'est l'anniversaire et dans la fenêtre de temps
    PromotionConditionType["BIRTHDAY_WINDOW"] = "birthday_window";
    // 💰 Montant minimum de la commande
    PromotionConditionType["ORDER_TOTAL"] = "order_total";
    // 📦 IDs des packs présents (ou absents) dans la commande
    PromotionConditionType["PACKS"] = "packs";
    // 🎯 IDs des variations de produits présentes (ou absentes)
    PromotionConditionType["PRODUCT_VARIATIONS"] = "product_variations";
    // 🏷️ Tags obligatoires dans la commande
    PromotionConditionType["TAGS"] = "tags";
    // 👤 IDs des clients ciblés
    PromotionConditionType["CUSTOMERS"] = "customers";
    // 🆕 Combien de commandes a fait le client
    PromotionConditionType["CUSTOMER_ORDER_TOTAL"] = "customer_order_total";
})(PromotionConditionType || (exports.PromotionConditionType = PromotionConditionType = {}));
var PromotionActionType;
(function (PromotionActionType) {
    PromotionActionType["ADD_PRODUCT_VARIATION"] = "add_product_variation";
    PromotionActionType["ADD_PACK"] = "add_pack";
    PromotionActionType["ORDER_DISCOUNT_FIXED"] = "order_discount_fixed";
    PromotionActionType["ORDER_DISCOUNT_PERCENTAGE"] = "order_discount_percentage";
    PromotionActionType["ITEMS_DISCOUNT_FIXED"] = "items_discount_fixed";
    PromotionActionType["ITEMS_DISCOUNT_PERCENTAGE"] = "items_discount_percentage";
})(PromotionActionType || (exports.PromotionActionType = PromotionActionType = {}));
var PromotionItemDiscountStrategy;
(function (PromotionItemDiscountStrategy) {
    // Application de remise à tous les items les moins chers (selon la quantité pour les conditions)
    // Exemple: 
    // Condition: 2 articles
    // Action: Ajoute produit à 10€
    // Le client à: 10€, 20€, 30€ et 40€ dans son panier
    // On remise donc tous les articles sauf celui à 40 euros car la condition est de 2 articles
    PromotionItemDiscountStrategy["ALL"] = "ALL";
    // Application de remise au moins cher.
    // On prend l'article le moins cher parmis les plus chers éligibles.
    // Exemple: 
    // - 10€, 20€, 30€
    // - On prend l'article 10€
    PromotionItemDiscountStrategy["CHEAPEST"] = "CHEAPEST";
    // Application de remise au moins cher.
    // On prend l'article le moins cher parmis les plus chers éligibles.
    // Exemple: 
    // - 10€, 20€, 30€
    // - On prend l'article 20€
    // L'objectif est de trouver la meilleur réduction pour le client final.
    PromotionItemDiscountStrategy["BEST_VALUE"] = "BEST_VALUE";
    // Application de remise au plus cher.
    // On prend l'article le plus cher parmis les plus chers éligibles.
    // Exemple: 
    // - 10€, 20€, 30€
    // - On prend l'article 30€
    PromotionItemDiscountStrategy["MOST_EXPENSIVE"] = "MOST_EXPENSIVE";
})(PromotionItemDiscountStrategy || (exports.PromotionItemDiscountStrategy = PromotionItemDiscountStrategy = {}));
const requiresCustomizationModal = (promotion) => {
    if (!promotion.actions || promotion.actions.length === 0 || !promotion.conditions || promotion.conditions.length === 0) {
        return false;
    }
    const hasRequiredAction = promotion.actions.some(action => [PromotionActionType.ADD_PRODUCT_VARIATION, PromotionActionType.ADD_PACK].includes(action.type));
    const hasRequiredCondition = promotion.conditions.some(condition => [PromotionConditionType.PRODUCT_VARIATIONS, PromotionConditionType.PACKS].includes(condition.type));
    return hasRequiredCondition || hasRequiredAction;
};
exports.requiresCustomizationModal = requiresCustomizationModal;
const isActionPromotion = (promotion) => {
    return (promotion.actions || []).length > 0;
};
exports.isActionPromotion = isActionPromotion;
// Le check sur le type est pour la rétrocompatibilité avec les promotions de type "legacy"
const isPromotion = (object) => {
    return 'actions' in object || 'type' in object;
};
exports.isPromotion = isPromotion;
